import { Injectable } from '@angular/core';
import { SearchTerm } from './search-term'
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Observable }  from 'rxjs/Observable';
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { Project } from './project'

@Injectable()
export class SearchTermService {
  currentSearchTerm: SearchTerm

  constructor(
    private arcs: ArcService,
    private rts: RuntimeService,
    private utils: UtilsService,
    private projects: ProjectService
  ) {
    this.arcs.sts = this
    this.projects.sts = this
  }

  newFromSaved(p: Project, params: Object) {
    new SearchTerm(this, p, params['id'], params['text'] || '???')
  }

  newSearchTerm() {
    let stid = this.utils.uniqueIdentifier
    if (!stid)
      return
    return new SearchTerm(this, this.rts.currentProject, stid, '')
  }

  save(st: SearchTerm): Observable<any> {
    st.isNew = false
    let obs = this.arcs.run({
      fun: 'saveSearchTerm',
      text: st.text,
      projectId: st.project.id,
      id: st.id
    })
    obs.subscribe((resp) => {
      console.log(122333, resp)
    })
    return obs
  }

  delete(st: SearchTerm): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteSearchTerm',
      id: st.id
    })
    obs.subscribe((resp) => st.project.searchTermsMap.delete(st.id))
    return obs
  }

}



// WEBPACK FOOTER //
// ./src/app/search-term.service.ts